import {
  type CurrentAdvertiserContext,
  type HeaderFooterContextInput,
  useAccountContextQuery,
} from '../generated/graphql-types';
import { useHirerAuth } from '@seek/hirer-auth-react';
import { getWindowLocation } from '../utils/window.ts';

const useQueryAccountInfo = () => {
  const { authenticated, loading: authLoading } = useHirerAuth();
  const { search, pathname } = getWindowLocation();
  const headerFooterContextInput: HeaderFooterContextInput = {
    location: { search, pathname },
  };

  const { data, error, loading } = useAccountContextQuery({
    skip: !authenticated,
    variables: { input: headerFooterContextInput },
  });

  const accountInfo = {
    advertiser: data?.headerFooterContext?.advertiser,
    user: data?.headerFooterContext?.user,
    identityContext: data?.headerFooterContext?.identityContext,
    currentAdvertiser: data?.currentAdvertiser as
      | CurrentAdvertiserContext
      | undefined,
  };

  return {
    accountInfo:
      (authenticated || authLoading) && !Boolean(error)
        ? accountInfo
        : undefined,
    loading,
    error,
  };
};

export { useQueryAccountInfo };
